import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';

import GetReasonTypesQuery from '@/graphql/contracts/getReasonTypes.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetReasonTypes } from '@/graphql/contracts/_generated_/getReasonTypes.query';
import { GetReasonCodesVariables } from '@/graphql/contracts/_generated_/getReasonCodes.query';
import { notificationService } from '@/services/notification/notification.client';

export function useGetReasonTypes() {
  const [reasonTypes, setReasonTypes] = useState<ReasonType[]>([]);

  const [_getReasonTypes, { data, loading }] = useLazyQuery<GetReasonTypes, GetReasonCodesVariables>(
    GetReasonTypesQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const getReasonTypes = () => {
    _getReasonTypes();
  };

  useEffect(() => {
    // console.log('update useGetReasonTypes', data, loading);
  });

  useEffect(() => {
    // console.log(apolloClientContracts.cache.extract())
    setReasonTypes(data?.reasonTypes ?? []);
  }, [data]);

  return {
    getReasonTypes,
    isLoading: loading,
    reasonTypes,
  } as const;
}
